export const API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3001/api"
    : "https://link.jamx.ai:3100/api";

export const AUXIGEN_API_URL = "https://api.auxigen.io";

export const adsTxtFixed = (group_id, display_id) => `
jamx.ai, ${group_id || 0}, DIRECT
audiopulsar.com, ${group_id || 0}, DIRECT
podium-audio.com, ${group_id || 0}, DIRECT`;

export const limitedAdminPages = [
  // "AdminDashboard",
  // "AdminNewDashboard",
  "AdminGroupsList",
  "CustomReports",
  "AdminSellers",
  "AdminPublisherOnboardingLinks",
  "AdminReportSchedules",
  "AdminUpdateSellerGroup",
  "AdminAddSeller",
  "AdminUpdateSeller",
  "AdminAddScheduledReport",
];

export const hostedOptionsSet = [
  { name: "Self", value: "self" },
  { name: "Simplecast Jamx", value: "simplecast_jx" },
  { name: "Simplecast Pulsar", value: "simplecast_ps" },
  { name: "Simplecast NeonNights", value: "simplecast_nn" },
  { name: "Omny", value: "omny" },
  { name: "Soundstack", value: "soundstack" },
  { name: "Libsyn", value: "libsyn" },
  { name: "Spreaker", value: "spreaker" },
  { name: "Demo", value: "demo" },
  { name: "Megaphone", value: "megaphone" },
  { name: "Acast", value: "acast" },
  { name: "Art-19", value: "art_19" },
  { name: "Megaphone Launchpod", value: "megaphone_launchpod" },
];

export const podcasterTypeOptions = [
  { label: "Individual", value: "individual" },
  { label: "Network", value: "network" },
  { label: "Publisher", value: "publisher" },
];
export const podcasterPlanOptions = [
  { label: "Trial", value: "trial" },
  { label: "Jamx Network", value: "jamx network" },
  { label: "Self", value: "self" },
];

export const AUXIGEN_TASK_STAGES = {
  PROCESSING_INTRO_OUTRO: "intro_outro_audio",
  GENERATING_SHOW_METADATA: "metadata",
  GENERATING_TRANSCRIPTS: "transcripts",
  GENERATING_EPISODES_AUDIO: "episodes_audio",
};

export const AUXIGEN_STAGE_LABELS = {
  [AUXIGEN_TASK_STAGES.PROCESSING_INTRO_OUTRO]: "Processing intro/outro audio",
  [AUXIGEN_TASK_STAGES.GENERATING_SHOW_METADATA]: "Generating show metadata",
  [AUXIGEN_TASK_STAGES.GENERATING_TRANSCRIPTS]: "Generating transcripts",
  [AUXIGEN_TASK_STAGES.GENERATING_EPISODES_AUDIO]: "Generating episodes audio",
};

export const MAX_AVG_MONTHLY_DOWNLOADS = 1_000_000_000;

export const PODCASTER_JOIN_NETWORK_EMAIL_TEMPLATES = {
  WAITING_LIST: {
    label: "Waiting List",
    value: "podcaster-waiting-list",
    requires: [],
  },
  CALENDAR_LINK: {
    label: "Calendar Link",
    value: "podcaster-calendar-link",
    requires: ["url"],
  },
  CALENDAR_LINK_STATIC: {
    label: "Calendar Link",
    value: "podcaster-calendar-link-static",
    requires: [],
  },
  CONTRACT_LINK: {
    label: "Contract Link",
    value: "podcaster-contract-link",
    requires: ["url"],
  },
};

export const DAYS_OF_WEEK = [
  { label: "Monday", value: 1 },
  { label: "Tuesday", value: 2 },
  { label: "Wednesday", value: 3 },
  { label: "Thursday", value: 4 },
  { label: "Friday", value: 5 },
  { label: "Saturday", value: 6 },
  { label: "Sunday", value: 7 },
];

export const MUSIC_CATEGORIES = [
  { label: "Happy", value: "happy" },
  { label: "Sad", value: "sad" },
  { label: "Serious", value: "serious" },
];

export const GENDER = {
  MALE: "male",
  FEMALE: "female",
  UNISEX: "unisex",
};

export const AVATAR_VOICE_GENDER_MAPPING = {
  openai: {
    onyx: GENDER.MALE,
    echo: GENDER.MALE,
    ash: GENDER.MALE,
    ballad: GENDER.MALE,
    cedar: GENDER.MALE,
    verse: GENDER.MALE,
    nova: GENDER.FEMALE,
    shimmer: GENDER.FEMALE,
    coral: GENDER.FEMALE,
    marin: GENDER.FEMALE,
    alloy: GENDER.UNISEX,
    sage: GENDER.UNISEX,
    fable: GENDER.UNISEX,
  },
  gemini_2_5: {
    Achird: GENDER.MALE,
    Algenib: GENDER.MALE,
    Algieba: GENDER.MALE,
    Alnilam: GENDER.MALE,
    Charon: GENDER.MALE,
    Enceladus: GENDER.MALE,
    Fenrir: GENDER.MALE,
    Iapetus: GENDER.MALE,
    Orus: GENDER.MALE,
    Puck: GENDER.MALE,
    Rasalgethi: GENDER.MALE,
    Sadachbia: GENDER.MALE,
    Sadaltager: GENDER.MALE,
    Schedar: GENDER.MALE,
    Umbriel: GENDER.MALE,
    Zubenelgenubi: GENDER.MALE,
    Achernar: GENDER.FEMALE,
    Aoede: GENDER.FEMALE,
    Autonoe: GENDER.FEMALE,
    Callirrhoe: GENDER.FEMALE,
    Despina: GENDER.FEMALE,
    Erinome: GENDER.FEMALE,
    Gacrux: GENDER.FEMALE,
    Kore: GENDER.FEMALE,
    Laomedeia: GENDER.FEMALE,
    Leda: GENDER.FEMALE,
    Pulcherrima: GENDER.FEMALE,
    Sulafat: GENDER.FEMALE,
    Vindemiatrix: GENDER.FEMALE,
    Zephyr: GENDER.FEMALE,
  },
};

// Mailgun email event metadata
export const MG_EVENT_OPTIONS = [
  { label: "Delivered", value: "delivered" },
  { label: "Failed (hard)", value: "failed" },
  { label: "Failed (soft)", value: "soft_fail" },
  { label: "Complained", value: "complained" },
  { label: "Unsubscribed", value: "unsubscribed" },
];

export const MG_EVENT_LABELS = {
  delivered: "Delivered",
  failed: "Hard fail",
  soft_fail: "Soft fail",
  complained: "Complaint",
  unsubscribed: "Unsubscribed",
  __none__: "No email data",
};

export const MG_EVENT_TOOLTIPS = {
  delivered: "Delivered to recipient inbox",
  failed: "Permanent failure (bounce/blocked)",
  soft_fail: "Temporary failure, will retry",
  complained: "Recipient reported spam/complaint",
  unsubscribed: "Recipient unsubscribed",
};

export const FAIL_REASON_OPTIONS = [
  { label: "Hard bounce", value: "bounce" },
  { label: "Previously bounced", value: "suppress-bounce" },
  { label: "Previously complained", value: "suppress-complaint" },
  { label: "Unsubscribed", value: "suppress-unsubscribe" },
  { label: "Blocked by ESP", value: "espblock" },
  { label: "Blacklisted", value: "blacklisted" },
  { label: "Greylisted", value: "greylisted" },
  { label: "Generic temp fail", value: "generic" },
  { label: "Message too old", value: "old" },
  { label: "Unknown", value: "unknown" },
];

export const FAIL_REASON_LABELS = Object.fromEntries(
  FAIL_REASON_OPTIONS.map((o) => [o.value, o.label])
);

export const PODCASTER_BANKING_FIELDS = [
  { key: "bank_name", label: "Bank Name" },
  { key: "account_name", label: "Account Name" },
  { key: "bank_account_number", label: "Bank Account Number" },
  { key: "iban", label: "IBAN" },
  { key: "swift", label: "SWIFT" },
  { key: "sort_code", label: "Sort Code" },
  { key: "routing_type", label: "Routing Type" },
  { key: "routing_value", label: "Routing Value" },
  { key: "currency", label: "Currency" },
  { key: "country", label: "Country" },
  { key: "city", label: "City" },
  { key: "postal_code", label: "Postal Code" },
  { key: "vendor_state", label: "State / Province" },
  { key: "street_address", label: "Street Address" },
  { key: "vat_number", label: "VAT Number" },
  { key: "payment_terms", label: "Payment Terms" },
  { key: "created_at", label: "Submitted At" },
  { key: "last_modified", label: "Last Modified" },
];

export const PODCAST_CATEGORY_GROUPS = {
  "Society & Culture": [
    "Society & Culture", "History", "Politics", "Government", "Social Sciences",
    "Personal Journals", "Documentary", "Culture", "True Crime", "News",
    "News Commentary", "Daily News", "Entertainment News", "Religion & Spirituality",
    "Christianity", "Judaism", "Spirituality",
  ],
  Business: [
    "Business", "Entrepreneurship", "Management", "Careers", "Investing",
    "Marketing", "Business News", "Management & Marketing", "Business:Marketing",
    "Personal Finance", "Technology", "Tech News",
  ],
  Educational: [
    "Education", "Self-Improvement", "How To", "Courses", "Language Learning",
    "Philosophy", "Education for Kids", "Science", "Earth Sciences", "Astronomy",
    "Life Sciences", "Natural Sciences",
  ],
  Sports: [
    "Sports", "Football", "Basketball", "Soccer", "Baseball", "Hockey",
    "Wrestling", "Cricket", "Golf", "Tennis", "Swimming", "Running",
    "Fantasy Sports", "Sports News", "Fitness",
  ],
  "Arts & Entertainment": [
    "Arts", "Performing Arts", "Comedy", "TV & Film", "Fiction", "Drama",
    "Film Reviews", "Film History", "Visual Arts", "Comedy Fiction",
    "Comedy Interviews", "Film Interviews", "TV Reviews", "After Shows",
    "Improv", "Science Fiction", "Games", "Video Games", "Music",
    "Music Interviews", "Music Commentary", "Music History",
  ],
  "Health & Lifestyle": [
    "Health & Fitness", "Mental Health", "Alternative Health", "Medicine",
    "Nutrition", "Health & Fitness:Mental Health", "Sexuality", "Relationships",
    "Kids & Family", "Parenting", "Stories for Kids", "Food", "Fashion & Beauty",
    "Leisure", "Hobbies", "Home & Garden", "Pets & Animals", "Nature",
  ],
};

export const SPOTIFY_SIGNUP_CATEGORIES = [
  "Society & Culture",
  "Business",
  "Educational",
  "Sports",
  "Arts & Entertainment",
  "Health & Lifestyle",
  "Other",
];

// Canonical approval-status definitions for accounting notifications
export const NOTIFICATION_STATUSES = [
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "sending", label: "Sending" },
  { value: "sent", label: "Sent" },
  { value: "failed", label: "Failed" },
];
